import styled from "styled-components";

export const DivPreview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 600px;
`;

export const Loader = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 8px;
  z-index: 2;
  font-size: 16px;
  font-weight: 500;
`;

export const PreviewIframe = styled.iframe`
  border: 1px solid #ccc;
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.5s ease;
  position: absolute;
  inset: 0;
  margin: auto;
  z-index: 1;
  width: 100%;
  height: 100%;
  pointer-events: none; 
`;

export const Fallback = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 8px;
  color: #666;
  font-size: 16px;
  font-weight: 500;
  z-index: 3;
  display: none;
`;